import { useRef } from 'react';

// Third party
import { useSnackbar } from 'notistack';

// Hooks
import { useLogoutAPI } from './API/welcome';

// Components
import { TAxiosError } from '../types/responses';

const useError = () => {
  const { logout } = useLogoutAPI();
  const { enqueueSnackbar } = useSnackbar();

  const hasTriggeredLogout = useRef(false);

  const getFallbackMessage = (status?: number) => {
    if (status === 500 || status === 503) {
      return 'There is a problem with the server. Please try again later.';
    }
    return 'Something went wrong. Please try again later.';
  };

  const handleReqError = async (error: TAxiosError) => {
    const errorDetail = error.response?.data?.detail;
    const status = error?.response?.status;

    if (!hasTriggeredLogout.current && (status === 401 || status === 403)) {
      if (!localStorage.getItem('authToken')) return false;

      hasTriggeredLogout.current = true;
      enqueueSnackbar('Session expired. Please log in again.', { variant: 'warning' });
      await logout();
      return false;
    }

    if (status === 400 && errorDetail === 'A user with this email already exists.') {
      enqueueSnackbar('Serial already exists', { variant: 'error' });
      return false;
    }

    const message =
      typeof errorDetail === 'string' && errorDetail.trim().length > 0
        ? errorDetail
        : getFallbackMessage(status);
    enqueueSnackbar(message, { variant: 'error' });

    return false;
  };

  return {
    handleReqError,
  };
};

export { useError };